import { keys } from "./Keys";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { ISummaryDTO } from "../../services/setpoint-administration-service/Models";
import SetpointAdministrationDataService from "../../services/setpoint-administration-service/SetpointAdministrationService";
import { useQuery } from "react-query";

export type UseSetpointDataParams = {
    groupID: number,
    organizationID: number,
    tagID: number
} & BaseUseQueryParameters<ISummaryDTO | undefined>;

export function useSimilarSetpointData({
    groupID,
    organizationID,
    tagID,
    enabled,    
    onSuccess,
    onError
}: UseSetpointDataParams) {
    return useQuery<ISummaryDTO, RestError>(
        keys.similarPoints(groupID, 
            organizationID,
            tagID
        ),
        ({ signal }) => {
            return SetpointAdministrationDataService.getSimilarSetpoints(
                groupID, 
                organizationID,
                tagID,
                signal
            );
        },
        {
            enabled,
            onError: onError,
            onSuccess: onSuccess,
            //refetchInterval: refreshSeconds ? refreshSeconds * 1000 : false,
            refetchInterval: false,
            refetchOnMount: true
        }
    );
}